import { render, staticRenderFns } from "./editCustomerDetails.vue?vue&type=template&id=504dda72&"
import script from "./editCustomerDetails.vue?vue&type=script&lang=ts&"
export * from "./editCustomerDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports